import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import get from 'transmute/get';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import { isLoading } from 'reference-resolvers/utils';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { getAssignmentRemovalProps } from '../operators/getAssignmentRemovalProps';
import { getAgentId, getAgentType } from 'conversations-inbox-lib/agent/public/operators';
import { AgentLocator } from 'conversations-inbox-lib/agent/public/records';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import ResolveReferences from 'reference-resolvers/ResolveReferences';
import { RESPONDER } from '../../reference-resolvers/constants/ResolverKeys';
import { getCachedAgentStatus } from 'conversations-inbox-lib/agent-status/public';
import { HUMAN } from 'conversations-inbox-lib/agent/public/constants';
import { client } from 'conversations-inbox-lib/data-fetching-client/public/clients';
import { jsx as _jsx } from "react/jsx-runtime";
const AssignmentRemovalOverlayMessageRenderer = ({
  overlay,
  assignee,
  initiatingAgent
}) => {
  const currentAgentStatus = getCachedAgentStatus(client);
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'AgentStatusRecord | undefined' i... Remove this comment to see the full error message
  const currentAgentId = getAgentId(currentAgentStatus);
  if (assignee && isLoading(assignee) || initiatingAgent && isLoading(initiatingAgent)) {
    return /*#__PURE__*/_jsx(UILoadingSpinner, {
      use: "tertiary"
    });
  }
  const assigneeLabel = assignee && /*#__PURE__*/_jsx("span", {
    children: assignee.label
  });
  const initiatingAgentLabel = initiatingAgent && /*#__PURE__*/_jsx("span", {
    children: initiatingAgent.label
  });
  const activeAgent = new AgentLocator({
    agentType: HUMAN,
    agentId: currentAgentId
  });
  const messageProps = getAssignmentRemovalProps(overlay, {
    activeAgent,
    assigneeLabel,
    initiatingAgentLabel
  });
  return /*#__PURE__*/_jsx(FormattedReactMessage, Object.assign({}, messageProps));
};
AssignmentRemovalOverlayMessageRenderer.displayName = 'AssignmentRemovalOverlayMessageRenderer';
const mapResolversToProps = (resolvers, props) => {
  const {
    overlay
  } = props;
  const initiatingAgent = get('initiatingAgent', overlay);
  const assignee = get('assignee', overlay);
  const resolverProps = {};
  if (assignee) {
    resolverProps.assignee = resolvers[RESPONDER].byId(`${getAgentId(assignee)}-${getAgentType(assignee)}`);
  }
  if (initiatingAgent) {
    resolverProps.initiatingAgent = resolvers[RESPONDER].byId(`${getAgentId(initiatingAgent)}-${getAgentType(initiatingAgent)}`);
  }
  return resolverProps;
};
const AssignmentRemovalOverlayMessage = ResolveReferences(mapResolversToProps)(AssignmentRemovalOverlayMessageRenderer);
AssignmentRemovalOverlayMessage.displayName = 'AssignmentRemovalOverlayMessage';
export default AssignmentRemovalOverlayMessage;